const SCREEN_WIDTHS: { [key: string]: number } = {
  phone: 480,
  tablet: 768,
  desktop: 992,
};

enum VIEWPORT {
  DESKTOP = 'desktop',
  MOBILE = 'mobile',
  TABLET = 'tablet',
}

function getViewportType(window: Window): VIEWPORT {
  const { phone, tablet } = SCREEN_WIDTHS;
  const width: number = getWindowWidth(window);
  let viewport: VIEWPORT;

  if (width <= phone) {
    viewport = VIEWPORT.MOBILE;
  } else if (width <= tablet && width > phone) {
    viewport = VIEWPORT.TABLET;
  } else {
    viewport = VIEWPORT.DESKTOP;
  }

  return viewport;
}

export function getWindowWidth(windowInstance: Window): number {
  const { document } = windowInstance;
  return (
    windowInstance.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth
  );
}

export const isDesktopViewport = (window: Window) =>
  getViewportType(window) === VIEWPORT.DESKTOP;
export const isMobileViewport = (window: Window) =>
  getViewportType(window) === VIEWPORT.MOBILE;
export const isTabletViewport = (window: Window) =>
  getViewportType(window) === VIEWPORT.TABLET;
